<template>
  <canvas ref="qrcode"></canvas>
</template>

<script>
import { toCanvas } from 'qrcode'

export default {
  name: 'QRCode',

  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => ({ width: 120 })
    }
  },

  watch: {
    value(newVal) {
      if (!newVal) return
      this.generateQrcode()
    }
  },

  mounted() {
    if (this.value) {
      this.generateQrcode()
    }
  },

  methods: {
    generateQrcode() {
      if (!this.value) return

      toCanvas(
        this.$refs.qrcode,
        String(this.value),
        this.options,
        err => {
          if (err) {
            console.error('[QR ERROR]', err)
          }
        }
      )
    }
  }
}
</script>
